import {
  useGetAllWorkspacesQuery,
  useGetWorkspacesQuery,
} from '@carboncopyco/data';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { usePermissionsContext } from '../../utils';
import { useDashboardProps } from '../DashboardContext';

type UseWorkspaceAccessProps = { workspaceId: string };

export const useWorkspaceAccess = ({
  workspaceId,
}: UseWorkspaceAccessProps) => {
  const { organizationId } = useDashboardProps();
  const { data: userWorkspaces } = useGetWorkspacesQuery(
    { organizationId },
    { skip: !organizationId }
  );

  const userHasWorkspaceAccess = userWorkspaces.some(
    (ws) => ws.id === workspaceId
  );
  const { getPermissions } = usePermissionsContext();
  const flags = useFlags();
  const expandWorkspacesPermission = getPermissions(
    PermissionKey.workspace,
    PermissionAction.getAllWorkspacesOfOrganization
  );

  const isAdminWithoutWorkspaceAccess =
    (flags.expandAdminRolePrivileges &&
      expandWorkspacesPermission &&
      !userHasWorkspaceAccess) ||
    undefined;

  const { data: allWorkspaces } = useGetAllWorkspacesQuery(
    { organizationId },
    { skip: !isAdminWithoutWorkspaceAccess }
  );
  const workspaceName = allWorkspaces?.find(
    (ws) => ws.id === workspaceId
  )?.workspaceName;

  return {
    isAdminWithoutWorkspaceAccess,
    userHasWorkspaceAccess,
    workspaceName,
  };
};
